import { useId } from "react"

interface NoDeviceIconProps {
  color: string
  width?: number
  height?: number
  style?: React.CSSProperties
}

const NoDeviceIcon = ({ color, width = 24, height = 24, style }: NoDeviceIconProps) => {
  // The mask cuts a gap around the slash. Its id has to be unique per icon on the page,
  // and useId returns colons, which break the url() reference.
  const maskId = `no-device-${useId().replace(/:/g, "")}`

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="white" />
        <path
          d="M4.5 6.5L19.5 21.5"
          stroke="black"
          strokeWidth="4.5"
          strokeLinecap="round"
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <g transform="translate(0 2)">
          <rect
            x="5.3335"
            y="8"
            width="13.3333"
            height="10.6667"
            rx="2.2857"
            fill={color}
          />
          <path
            d="M18.6608 4.88594C18.6402 5.02691 18.5602 5.15601 18.4415 5.23837C18.3494 5.30207 18.2436 5.3335 18.1378 5.3335C17.9795 5.3335 17.822 5.26302 17.7171 5.12968C16.3285 3.3819 14.2448 2.37978 12.0002 2.37978C9.75555 2.37978 7.67183 3.3819 6.28411 5.12968C6.10774 5.35132 5.78942 5.39891 5.55885 5.23837C5.44012 5.15601 5.36011 5.02691 5.33946 4.88594C5.31796 4.74411 5.35495 4.60398 5.44443 4.49188C7.03432 2.48424 9.42348 1.3335 12.0002 1.3335C14.5768 1.3335 16.966 2.48424 18.5559 4.49188C18.6454 4.60398 18.6824 4.74411 18.6608 4.88594Z"
            fill={color}
          />
          <path
            d="M15.9967 6.21181C15.9782 6.35611 15.8991 6.48693 15.7812 6.57048L15.7728 6.57638C15.6836 6.63714 15.5817 6.66667 15.4815 6.66667C15.3342 6.66667 15.1878 6.60168 15.0851 6.47931C14.3199 5.56457 13.1954 5.03966 12.001 5.03966C10.8065 5.03966 9.682 5.56457 8.91686 6.47931C8.74178 6.68777 8.44296 6.72743 8.22158 6.57048L8.21148 6.5637C8.09869 6.47931 8.02378 6.35189 8.00526 6.21181C7.98674 6.06834 8.02882 5.92236 8.12142 5.81097C9.08352 4.65992 10.4976 4 12.001 4C13.5043 4 14.9184 4.65992 15.8797 5.81097C15.9731 5.92236 16.0152 6.06834 15.9967 6.21181Z"
            fill={color}
          />
        </g>
      </g>
      <path
        d="M4.5 6.5L19.5 21.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default NoDeviceIcon
